import type { SpeedFilterOption } from "../types/components.types";

export const SPEED_FILTER_OPTIONS: SpeedFilterOption[] = [
	{
		id: 1,
		label: "Movendo",
		bgColor: "bg-green-100",
		textColor: "text-green-700",
		filterFn: (item) => item.moving === true,
	},
	{
		id: 0,
		label: "Parado",
		bgColor: "bg-red-100",
		textColor: "text-red-700",
		filterFn: (item) => item.moving === false,
	},
];
